import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    contactDialog: false, // 初始化为 false，可以根据需要修改
    isMobile: false,
    visibleHeight: 0 // 根据你的需求定义全局变量的初始值
  },
  mutations: {
    setIsMobile(state, isMobile) {
      // console.log("🚀 ~ mutations ~ window.innerWidth:", window);
      // console.log("🚀 ~ setIsMobile ~ isMobile:", isMobile);
      state.isMobile = isMobile;
    },
    setVisibleHeight(state, value) {
      state.visibleHeight = value;
    },
    setContactDialog(state, value) {
      state.contactDialog = value; // 定义一个 mutation 来改变 contactDialog 状态
    }
  },
  actions: {
    updateContactDialog({
      commit
    }, value) {
      commit('setContactDialog', value); // 使用 action 来提交 mutation
    }
  },
  getters: {
    getIsMobile: state => state.isMobile,
    getVisibleHeight: state => state.visibleHeight,
    getContactDialog: state => state.contactDialog // 使用 getter 来访问 contactDialog 状态
  }
});